import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Stack,
  Box,
} from '@mui/material';
import { Link } from 'react-router-dom';

interface KubernetesConnectionDialogProps {
  open: boolean;
  onClose: () => void;
  teleportUrl: string | undefined;
  k9sUrl: string | undefined;
}

export const KubernetesConnectionDialog: React.FC<
  KubernetesConnectionDialogProps
> = ({ open, onClose, teleportUrl, k9sUrl }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Kubernetes Cluster Access</DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          You can access the Kubernetes cluster via <strong>Teleport</strong>{' '}
          then manage it directly through <strong>K9s</strong>.
        </Typography>

        <Stack spacing={3} mt={2}>
          <Box>
            <Typography variant="h6">🔐 Connect to Teleport</Typography>
            <Typography variant="body2" color="textSecondary">
              Teleport provides secure browser-based and CLI access to
              Kubernetes clusters.
            </Typography>
            {teleportUrl ? (
              <Button
                component={Link}
                to={teleportUrl}
                variant="contained"
                color="primary"
                sx={{ mt: 1 }}
              >
                Teleport Documentation
              </Button>
            ) : (
              <Typography
                color="textSecondary"
                sx={{ mt: 1, fontStyle: 'italic' }}
              >
                Teleport documentation not available
              </Typography>
            )}
          </Box>

          <Box>
            <Typography variant="h6">💻 Access to K9s</Typography>
            <Typography variant="body2" color="textSecondary">
              Use K9s to manage your cluster from the terminal using a
              text-based dashboard.
            </Typography>
            {k9sUrl ? (
              <Button
                component={Link}
                to={k9sUrl}
                variant="outlined"
                color="secondary"
                sx={{ mt: 1 }}
              >
                K9s Guide
              </Button>
            ) : (
              <Typography
                color="textSecondary"
                sx={{ mt: 1, fontStyle: 'italic' }}
              >
                K9s guide not available
              </Typography>
            )}
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
